export const LEGAL_ACCEPTANCE_PENDING_EVENT_NAME = 'zoofizjo:legal-acceptance-pending';
